import {createStyles, Theme} from "@material-ui/core";
import {styleColors} from "src/main.style";

export const AgreementCardStyle = (theme: Theme) =>
    createStyles({
        card: {
            padding: '10px 20px',
            background: styleColors.white,
            border: `1px solid ${styleColors.blackAlpha23}`,
            boxShadow: `0px 4px 4px ${styleColors.blackAlpha23}`,
            borderRadius: '14px',
            display: 'flex',
            flexDirection: 'column',

            [theme.breakpoints.up("md")]: {
                flex: '0 0 320px',
            },
        },
        heading2: {
            fontFamily: 'Metropolis',
            fontStyle: 'normal',
            fontWeight: 700,
            fontSize: '13px',
            lineHeight: '13px',
            whiteSpace: 'nowrap',
        },
        heading2LineThrough: {
            fontFamily: 'Metropolis',
            fontStyle: 'normal',
            fontWeight: 700,
            fontSize: '13px',
            lineHeight: '13px',
            textDecorationLine: 'line-through',
            color: styleColors.warmGrey,
        },
        body1: {
            fontFamily: 'Metropolis',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '8px',
            lineHeight: '8px',
            display: 'flex',
            alignItems: 'center',
            letterSpacing: '1px',
            textTransform: 'uppercase',
            color: styleColors.warmGrey,
        },
        body2: {
            fontFamily: 'Metropolis',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '9px',
            lineHeight: '13px',
            display: 'flex',
            alignItems: 'center',
            letterSpacing: '1px',
            textTransform: 'uppercase',
            color: styleColors.warmGrey,
        },
        body3: {
            fontFamily: 'Metropolis',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '10px',
            lineHeight: '11px',
            color: styleColors.black,
        },
        cardContentListItem: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            padding: '10px 0',
            minWidth: 0,
        },
        itemTopRow: {
            display: 'flex',
            flexDirection: 'row',
            gap: '8px',
            alignItems: 'center',
        },
        itemMiddleRow: {
            flex: 1,
            display: 'flex',
            flexDirection: 'row',
            gap: '8px',
            background: styleColors.greyLight1,
            borderRadius: '4px',
            padding: '8px 12px',
            margin: '12px 0px',
        },
        splitAgreement: {
            display: 'flex',
            flexDirection: 'row',
            gap: '4px',
            justifyContent: 'flex-end',
            alignItems: 'center',
            flexWrap: 'wrap',
        },
        splitAgreementItem: {
            display: 'flex',
            flexDirection: 'row',
            gap: '4px',
            justifyContent: 'flex-end',
            flexWrap: 'wrap',
            alignItems: 'center',
        },
        splitAgreementItemLineThrough: {
            position: 'relative',
            display: 'flex',
            flexDirection: 'row',
            gap: '4px',
            justifyContent: 'flex-start',
            alignItems: 'center',
            opacity: 0.5,
        },
        absoluteLineThrough: {
            display: 'block',
            position: 'absolute',
            top: '50%',
            left: '-4px',
            width: 'calc(100% + 4px)',
            height: '1px',
            backgroundColor: styleColors.warmGrey,
            zIndex: 1,
        },
        cardActions: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-around',
            gap: '8px',
            marginTop: '12px',
        },
        descriptionWrapper: {
            flex: 1,
            padding: '8px 0',
        },
        galleryList: {
            display: 'flex',
            flexDirection: 'row',
            gap: '8px',
            flex: 1,
        },
        galleryListItem: {
            flex: 1,
            position: 'relative',
            overflow: 'hidden',
            borderRadius: '4px',
            maxHeight: '80px',

            '& > img': {
                objectFit: 'cover',
                objectPosition: 'center',
                height: '100%',
                width: 'auto',
            },
        },
        ColAlignRight: {
            display: 'flex',
            alignItems: 'flex-end',
            flexDirection: 'column',
            flexWrap: 'wrap',
            gap: '4px',
            flex: 1,
            flexBasis: '30%',
        },
        leftActions: {
            flex: 1,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
        },
        rightActions: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            alignItems: 'center',
        }
    });



// WEBPACK FOOTER //
// ./src/components/economy/AgreementCard.style.ts